import { render, staticRenderFns } from "./Top_new.vue?vue&type=template&id=712d5e79&scoped=true"
import script from "./Top_new.vue?vue&type=script&lang=js"
export * from "./Top_new.vue?vue&type=script&lang=js"
import style0 from "./Top_new.vue?vue&type=style&index=0&id=712d5e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d5e79",
  null
  
)

export default component.exports